import classNames from 'classnames';
import { t } from 'i18next';
import { Card, Loading, Row, Text, Col, Space } from 'ui';
import { useTodosQuery } from '../../queries/useTodosQuery';
import { TodosWidgetEmptyState } from './TodosWidgetEmptyState';
import { TodosWidgetItem } from './TodosWidgetItem';

type P = {
  userId: string;
  numberOfNotifications: number;
  unreadMessages: number;
  className?: string;
  hideTodosFeedCta?: boolean;
};

const TodosWidget = ({ userId, unreadMessages, numberOfNotifications, className, hideTodosFeedCta }: P) => {
  // TODO Clear cache on user logout instead of using query key in future
  // TODO missing error state handling
  const { data, isLoading, dataUpdatedAt } = useTodosQuery(userId);
  const currentDate = t('dateFormatShortMonthDayYear', { date: new Date() });
  const numberOfTodos = data?.length ?? 0;

  if (isLoading) {
    // TODO fix duplicity, but before was bad loading state this is nicer
    return (
      <Card
        extra={<Text item={{ type: 'secondary' }}>{currentDate}</Text>}
        title={
          <span>
            {t(`To-Dos for today`, {
              numberOfTodos: '?',
            })}
          </span>
        }
        className={classNames('todos-widget', className)}
      >
        <div className="todos-widget__empty">
          <Loading />
        </div>
      </Card>
    );
  }

  const lastUpdatedComponent = (
    <Row item={{ justify: 'center', className: 'todos-widget__last-update' }}>
      <Text item={{ type: 'secondary' }}>
        {t(`Last updated on`, {
          lastUpdateTime: new Date(dataUpdatedAt),
        })}
      </Text>
    </Row>
  );

  return (
    <Card
      extra={<Text item={{ type: 'secondary' }}>{currentDate}</Text>}
      title={
        <span>
          {t(`To-Dos for today`, {
            numberOfTodos,
          })}
        </span>
      }
      className={classNames('todos-widget', className)}
    >
      {numberOfTodos > 0 ? (
        <>
          <Row item={{ className: 'todos-widget__list' }}>
            {data?.map((todoItem) => (
              <Col item={{ span: 24, className: 'todos-widget__list__item' }}>
                <TodosWidgetItem todoItemData={todoItem} />
              </Col>
            ))}
          </Row>
          {lastUpdatedComponent}
        </>
      ) : (
        <Space size="large" direction="vertical" className="todos-widget__empty">
          <TodosWidgetEmptyState
            unreadMessages={unreadMessages}
            newNotifications={numberOfNotifications}
            hideTodosFeedCta={hideTodosFeedCta}
          />
          {lastUpdatedComponent}
        </Space>
      )}
    </Card>
  );
};

export default TodosWidget;
